const VALID_FREQUENCIES = new Set(['none', 'weekly', 'monthly'])

export function normalizeReconciliationEmails(emails) {
  if (!Array.isArray(emails)) return []
  return emails
    .map(email =>
      String(email || '')
        .trim()
        .toLowerCase(),
    )
    .filter(Boolean)
    .filter((email, index, list) => list.indexOf(email) === index)
}

export function normalizeReconciliationFrequency(frequency) {
  const value = String(frequency || 'none')
    .trim()
    .toLowerCase()
  return VALID_FREQUENCIES.has(value) ? value : 'none'
}

export function normalizeReconciliationEmailSettings(venue = {}) {
  return {
    emails: normalizeReconciliationEmails(venue.reconciliationReportEmails),
    frequency: normalizeReconciliationFrequency(
      venue.reconciliationReportFrequency,
    ),
  }
}

export function buildReconciliationEmailSettingsPayload({
  emails = [],
  frequency = 'none',
} = {}) {
  return {
    reconciliationReportEmails: normalizeReconciliationEmails(emails),
    reconciliationReportFrequency: normalizeReconciliationFrequency(frequency),
  }
}
